import React, { useState, useEffect } from 'react';
import InputEntidad from '../../common/InputEntidad';
import DatePickerCustom from '../../common/DatePickerCustom';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {object, func, bool, string} from 'prop-types';
import {CloneObject} from '../../../utils/helpers';
import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import {useEntidad} from '../../hooks/useEntidad';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {isNull} from '../../../utils/validator';
import {TIPS} from "../../../consts/tips";
import {Accordion, FormError, FormLabel, Modal} from "../../common";

const ControladorCuentaModal = (props) => {

    const entityInit = {
        id: 0,
        idCuenta: 0,
        idTipoControlador: 0,
        idControlador: 0,
        fechaDesde: null,
        fechaHasta: null
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        idTipoTributo: 0,
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            idTipoControlador: props.data.entity.idTipoControlador,
            idControlador: props.data.entity.idControlador,
            fechaDesde: props.data.entity.fechaDesde,
            fechaHasta: props.data.entity.fechaHasta,
            idTipoTributo: props.data.idTipoTributo
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idTipoControlador: 0,
        idControlador: 0,
        idTipoTributo: 0,
        fechaDesde: null,
        fechaHasta: null
    });

    const [, getRowEntidad] = useEntidad({
        entidades: ['TipoControlador'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'TipoControlador',
            timeout: 0
        }
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.idTipoControlador = parseInt(formValues.idTipoControlador);
        row.idControlador = parseInt(formValues.idControlador);
        row.fechaDesde = formValues.fechaDesde;
        row.fechaHasta = formValues.fechaHasta;

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idControlador <= 0) errors.idControlador = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    const getDescTipoControlador = (id) => {
        const row = getRowEntidad('TipoControlador', id);
        return (row) ? row.nombre : '';
    }

    return (
        <Modal
            size="lg"
            title={`Controlador de la cuenta: ${(state.entity.id > 0) ? getDescTipoControlador(state.entity.idTipoControlador) : "Nuevo"}`}
            tipName={TIPS.NAME.MODALS.CONTROLADOR_CUENTA_MODAL}
            onEscape={() => props.onDismiss()}
            body={(
                            <div className="row">

                                <div className="mb-3 col-12">
                                    <Accordion title="Información del controlador " startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12">
                                                <label htmlFor="idTipoControlador" className="form-label">Tipo de
                                                    controlador</label>
                                                <InputEntidad
                                                    name="idTipoControlador"
                                                    tipName={TIPS.NAME.MODALS.TIPO_CONTROLADOR_MODAL}
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idTipoControlador}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Tipo controlador"
                                                    entidad="TipoControlador"
                                                    onFormat={(row) => (row) ? `${row.codigo} - ${row.nombre}` : ''}
                                                    filter={(row) => {
                                                        return (isNull(row.idTipoTributo) || row.idTipoTributo === formValues.idTipoTributo);
                                                    }}
                                                    memo={false}
                                                />
                                                <FormError />
                                            </div>

                                            <div className="mb-3 col-12">
                                                <FormLabel htmlFor="idControlador" required>Controlador</FormLabel>
                                                <InputEntidad
                                                    name="idControlador"
                                                    tipName={TIPS.NAME.MODALS.CONTROLADOR_MODAL}
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idControlador') ? 'is-invalid' : ''}`}
                                                    value={formValues.idControlador}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Controlador"
                                                    entidad="Controlador"
                                                    onFormat={(row) => (row && row.id) ? `${row.nombrePersona} (Legajo: ${row.legajo})` : ''}
                                                    filter={(row) => {
                                                        return (formValues.idTipoControlador === 0 || row.idTipoControlador === formValues.idTipoControlador);
                                                    }}
                                                    columns={[
                                                        {
                                                            Header: 'Tipo de controlador',
                                                            Cell: (props) => getDescTipoControlador(props.value),
                                                            accessor: 'idTipoControlador',
                                                            width: '20%'
                                                        },
                                                        {Header: 'Número', accessor: 'numero', width: '10%'},
                                                        {Header: 'Legajo', accessor: 'legajo', width: '20%'},
                                                        {
                                                            Header: 'Nombre y apellido',
                                                            accessor: 'nombrePersona',
                                                            width: '50%'
                                                        }
                                                    ]}
                                                    memo={false}
                                                />
                                                <FormError message={errorOf('idControlador')} />
                                            </div>

                                            <div className="mb-3 col-6">
                                                <label htmlFor="fechaDesde" className="form-label">Fecha
                                                    desde</label>
                                                <DatePickerCustom
                                                    name="fechaDesde"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaDesde}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>

                                            <div className="mb-3 col-6">
                                                <label htmlFor="fechaHasta" className="form-label">Fecha
                                                    hasta</label>
                                                <DatePickerCustom
                                                    name="fechaHasta"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaHasta}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    minValue={formValues.fechaDesde}
                                                />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional ">
                                        <DataTaggerFormRedux
                                            title="Información adicional de Controladores de la Cuenta"
                                            tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_CONTROLADOR_CUENTA_MODAL}
                                            processKey={props.processKey}
                                            entidad="ControladorCuenta"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>
                            </div>
            )}
            footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
            </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
            )}
            footerClassName={props.disabled ? 'f-align' : ''}
        />
    );
}

ControladorCuentaModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

ControladorCuentaModal.defaultProps = {
    disabled: false
};

export default ControladorCuentaModal;